import {
  GetDashboardWorkLetterUsageQueryVariables,
  useGetDashboardWorkLetterUsageQuery,
} from 'src/api';

type DashboardWorkLetterUsageHookParams = {
  variables: GetDashboardWorkLetterUsageQueryVariables;
  skip?: boolean;
};

export const useDashboardWorkLetterUsage = (params: DashboardWorkLetterUsageHookParams) => {
  const { variables, skip } = params;

  const { data, loading: isDashboardWorkLetterUsageLoading } = useGetDashboardWorkLetterUsageQuery({
    variables,
    skip,
  });

  const dashboardWorkLetterUsageItems = data?.getDashboardWorkLetterUsage ?? [];

  return {
    dashboardWorkLetterUsageItems,
    isDashboardWorkLetterUsageLoading,
  };
};
